<div class="search-wrapper mt-1" (blur)="hadText = false">
  <div class="input-group input-group-sm" >
    <input type="text" autocomplete="off" [style.caretColor]="accentColor" class="form-control editable" [placeholder]="placeholderText" [(ngModel)]="searchText" #dashModuleSearch (keyup.arrowup)="moveSelectionUp()" (keyup.arrowdown)="moveSelectionDown()" (keyup.escape)="(dashModuleSearch.value.length) ? clearEvent() : null" (keyup)="processKeyEvent($event)" aria-label="Search" aria-describedby="basic-addon2" matTooltip="Press Enter to search, Esc to clear" aria-label="Search">
    <div class="input-group-append">
      <button class="btn btn-outline-primary" [title]="!hadText ? 'Show List' : 'Hide List'" name="basic-addon3" *ngIf="allDataDropdown" type="button" (click)="openDropdown()" (keyup.arrowup)="moveSelectionUp()" (keyup.arrowdown)="moveSelectionDown()" (keyup.enter)="processKeyEvent($event)">
        <i class="fal" [ngClass]="{'fa-chevron-square-down': !hadText, 'fa-chevron-square-up': hadText}"></i>
      </button>
      <button *ngIf="!selectionMode" class="btn btn-primary" name="basic-addon2" [disabled]="dashModuleSearch.value.length < 2" type="button" (click)="searchEvent(dashModuleSearch.value)">
        <i class="fal fa-search"></i>
      </button>
    </div>
  </div>
  <div *ngIf="dropDown">
    <ng-container *ngTemplateOutlet="defaultDataDropdown"></ng-container>
  </div>
  <!-- <div *ngIf="configureMode">
    <ng-container *ngTemplateOutlet="defaultConfiguration"></ng-container>
  </div> -->
</div>

<ng-template #defaultConfiguration>
  <div class="popoverconfiguration" style="font-size: 1rem;" [style.z-index]="zIndex">
    <div *ngIf="fieldsEnabledCount < 1" class="alert alert-warning small"><i class="fal fa-exclamation-triangle"></i> You have disabled all search fields. <br> No results will be retrieved.</div>
    <!-- <h6>Search these fields: <div class="close" (click)="configureMode = false">&times;</div></h6> -->

    <div class="container">
      <div class="row" *ngFor="let f of modularSearchFields">
        <div class="col">
          <label class="fieldLabel" [for]="'sc' + f.fieldName + f.displayName">{{ f.displayName }}</label>
        </div>
        <div class="col">
          <label class="switch">
            <input [id]="'sc' + f.fieldName + f.displayName" type="checkbox" (change)="searchEvent(dashModuleSearch.value)" [(ngModel)]="f.enabled">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #defaultDataDropdown>
  <div *ngIf="hadText">
    <div *ngIf="dataToShow.length > 0; else noResults" class="search-dropdown">
      <cdk-virtual-scroll-viewport class="scrollViewport" [itemSize]="maxResults">
        <ul>
          <ng-container *cdkVirtualFor="let match of dataToShow; let i = index; trackBy: trackByUID; templateCacheSize: 1">
            <li class="search-match" [ngClass]="{'highlight': i == keySelectionIndex}" (click)="outputModel(match)">
              <span class="ms-2 matchName">
                {{ setTextToDisplay(match) }}
                <span class="badge badge-secondary ms-3 pe-2 ps-2" style="justify-content: flex-end; align-items: start; color: var(--RAred);" matTooltip="Number of times this battle has been used">{{ match.appears }}</span>
              </span>
            </li>
          </ng-container>
        </ul>
      </cdk-virtual-scroll-viewport>
    </div>
    <ng-template #noResults>
      <div class="search-dropdown no-results dropdown-intro">
        <span *ngIf="fieldsEnabledCount < 1"><i class="fal fa-exclamation-triangle"></i> You have disabled all search fields. Press the <i [class]="'fal fa-sm fa-fw ' + configIcon"></i> button to change this.</span>
        No results.
      </div>
    </ng-template>
  </div>
</ng-template>
